module.exports = __webpack_public_path__ + "static/media/plusRep.6b7a5d11.svg";